import { BuildRentStageType } from './BuildRentStageType';

export const BuildRentStageTypeOptions = [
    {
        id: BuildRentStageType.Build,
        name: 'Build',
    },
    {
        id: BuildRentStageType.Rent,
        name: 'Rental',
    },
];
